import { TableRowNoDataFound } from '@publicisgroupe/p-os-components';
import { Table } from 'semantic-ui-react';
import { t } from 'utils/resources';

import './NoData.less';

export const NoData = () => {
  return (
    <div className="no-data-section">
      <Table>
        <Table.Body>
          <TableRowNoDataFound colSpan="1" errorText={t('HelpSectionNoData')} />
        </Table.Body>
      </Table>
    </div>
  );
};
